export const convertToFraction = (fractionString: string) => {
    const [whole, mixed, numerator, denominator] = fractionString.match(/(\d*)[-\s]*(\d*)\s*\/\s*(\d+)/) || [];

    const wholePart = whole ? parseInt(whole, 10) : 0;
    const mixedPart = mixed ? parseInt(mixed, 10) : 0;
    const numeratorPart = numerator ? parseInt(numerator, 10) : 0;
    const denominatorPart = parseInt(denominator, 10);

    const totalNumerator = wholePart * denominatorPart + mixedPart * denominatorPart + numeratorPart;

    return {
        whole: Math.floor(totalNumerator / denominatorPart),
        numerator: totalNumerator % denominatorPart,
        denominator: denominatorPart,
    };
};

export const compareFractions = (fraction1: any, fraction2: any) => {
    const value1 = fraction1.whole + fraction1.numerator / fraction1.denominator;
    const value2 = fraction2.whole + fraction2.numerator / fraction2.denominator;

    if (value1 < value2) {
        return -1;
    } else if (value1 > value2) {
        return 1;
    } else {
        return 0;
    }
};

export const convertToDecimal = (fractionString: string): number => {
    const parts = fractionString.split(/[\s-]+/);
    if (parts.length > 0) {
        const wholePart = parseInt(parts[0], 10) || 0;
        if (parts.length > 1) {
            const [numerator, denominator] = parts[1].split('/').map(Number);
            const fractionPart = numerator / denominator;
            return parseFloat((wholePart + fractionPart).toFixed(2));
        } else if (fractionString.includes('/')) {
            const [numerator, denominator] = fractionString.split('/').map(Number);
            const fractionPart = numerator / denominator;
            return parseFloat(fractionPart.toFixed(2));
        } else {
            return wholePart;
        }
    } else {
        return 0;
    }
};

export const COLORS: string[] = [
    '#DB2900', '#DA5200', '#D77800', '#D0A200', '#C9CA00', '#9ACB00',
    '#00CEA3', '#00CD78', '#00D55B', '#00CD00', '#00CC00', '#66CB00',
    '#00CDCB', '#00A8CD', '#0099D3', '#0083DB', '#2F68DE', '#4544E0',
    '#643EDE', '#8034DC', '#9E21D9', '#B500D0', '#DC00D0', '#DC00AA',
    '#B22F02', '#AF4B00', '#AD6600', '#AA8700', '#A3A300', '#80A400',
    '#00A687', '#00A667', '#00A646', '#00A510', '#25A500', '#5CA400',
    '#00A6A5', '#008AA6', '#007EAA', '#1B71AF', '#325CB3', '#4341B7',
    '#593DB5', '#6D35B1', '#842CB1', '#9503A9', '#B200A8', '#B2008B',
];

export const validateClassAndSubmodelNames = (value: string) => {
    // must be entered in upper case, No characters other than letters and numbers, cannot being with number 
    if (/^[A-Z][A-Z0-9\s]*$/.test(value)) {
        return true;    
    } 
    return false;
}






